// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__3Ksdw","open":"App_open__2rwvS","customTransition":"App_customTransition__1yhD7","close":"App_close__RQZd6"};